<mat-card class="default-card grid-all">
    <mat-card-header>
        <mat-card-title>{{ title }}</mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <div class="form-panel-container">
            <form [formGroup]="stateForm" class="form">
                <div class="form-container">
                    <div class="form-item">
                        <mat-form-field>
                            <mat-label>Nom</mat-label>
                            <input matInput type="text" formControlName="name" autocomplete="off" tabindex="1" />
                        </mat-form-field>
                    </div>
                </div>
            </form>
        </div>
    </mat-card-content>
    <mat-card-actions>
        @if (data.readonly === true) {
            <button mat-raised-button class="accent-button" (click)="onCancel()">Ok</button>
        } @else {
            <button mat-stroked-button class="accent-button" (click)="onCancel()">Annuler</button>
            <button mat-raised-button class="accent-button" (click)="onConfirm()">Valider</button>
        }
    </mat-card-actions>
</mat-card>
